import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

class QCListView extends React.Component {
  static propTypes = {
    router: PropTypes.shape({
      push: PropTypes.func
    }),
    qcResults: PropTypes.shape({}),
    listQc: PropTypes.func
  }

  static defaultProps = {
    qcResults: {},
    router: {},
    listQc: _.noop
  }

  componentDidMount () {
    const { listQc } = this.props
    listQc()
  }

  goToQC = (qcResult) => {
    const { router } = this.props
    return router.push(`/qc/${qcResult.device_string}/${qcResult.id}`)
  }

  render () {
    const { qcResults } = this.props
    return (
      <div>
        <table className='table table-striped'>
          <thead className='thead-light'>
            <tr>
              <th scope='col'>QC ID</th>
              <th scope='col'>Created At</th>
              <th scope='col'>Device String</th>
              <th scope='col'>Passed</th>
            </tr>
          </thead>
          <tbody>
            {
              _.map(qcResults, (qcResult) => ((
                <tr
                  style={{ cursor: 'pointer' }}
                  onClick={() => this.goToQC(qcResult)}
                >
                  <td>
                    {qcResult.id}
                  </td>
                  <td>
                    {qcResult.created_at}
                  </td>
                  <td>
                    {qcResult.device_string}
                  </td>
                  <td>
                    {qcResult.passed}
                  </td>
                </tr>
              )))
            }
          </tbody>
        </table>
      </div>
    )
  }
}

export default QCListView



// WEBPACK FOOTER //
// ./src/routes/QCList/components/QCListView.jsx